var map = {
	"./groupAboutDirective.js": 3188,
	"./groupBaseDirective.js": 5041,
	"./groupCatalogItemDirective.js": 2148,
	"./groupCommentsDirective.js": 370,
	"./groupTabDirective.js": 5405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8666;